export const GET_LATEST_SO_CART_ENDPOINT = '/OsimCart/GetLatestSOCarts';
